import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    padding: theme.spacing(5),
    borderTop: `solid 1px ${theme.colorPalette.white_30_op_30}`
  },
  requirementsContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2)
  },
  requirements: {
    display: 'block',
    color: theme.colors.white
  },
  bulletPoints: {
    margin: 0,
    fontWeight: 400,
    paddingInlineStart: theme.spacing(5),
    paddingInlineEnd: theme.spacing(6)
  }
});

export default makeStyles(styles);
